import { useDispatch, useSelector } from "react-redux";
import { selectIsPasswordRecoverLoading } from "../../redux/password-recovery/selectors";
import {
  forgotPasswordStart,
  resetPasswordStart,
} from "../../redux/password-recovery/reducer";

const usePasswordRecovery = () => {
  const dispatch = useDispatch();
  const isLoadingPasswordRecovery = useSelector(selectIsPasswordRecoverLoading);

  const recoverPassword = (data) => {
    dispatch(forgotPasswordStart(data));
  };
  const resetPassword = (data) => {
    dispatch(resetPasswordStart(data));
  };
  return {
    isLoadingPasswordRecovery,
    recoverPassword,
    resetPassword,
  };
};

export default usePasswordRecovery;
